import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent implements OnInit {
  @ViewChild('c') c: ElementRef;
  matrix: any;

  constructor() { }

  ngOnInit() {
    console.log('asdasdas', this.c.nativeElement)
        // matrix
          // geting canvas by id c
          let c = this.c;
          let ctx = c.nativeElement.getContext("2d");
      
          //making the canvas full screen
          c.nativeElement.height = window.innerHeight;
          c.nativeElement.width = window.innerWidth;
      
          //chinese characters - taken from the unicode charset
          this.matrix = "RICHARDFREYREYES";
          //converting the string into an array of single characters
          this.matrix = this.matrix.split("");

          // console.log('this.matrix A', this.matrix);
      
          let font_size = 10;
          let columns = c.nativeElement.width/font_size; //number of columns for the rain
          //an array of drops - one per column
          let drops = [];
          //x below is the x coordinate
          //1 = y co-ordinate of the drop(same for every drop initially)
          for(let x = 0; x < columns; x++)
              drops[x] = 1;
      
          //drawing the characters
          function draw() {
              //chinese characters - taken from the unicode charset
              this.matrix = "RICHARDFREYREYES";
              //converting the string into an array of single characters
              this.matrix = this.matrix.split("");
              //Black BG for the canvas
              //translucent BG to show trail
              ctx.fillStyle = "rgba(0, 0, 0, 0.04)";
              ctx.fillRect(0, 0, c.nativeElement.width, c.nativeElement.height);
      
              ctx.fillStyle = "#0F0"; //green text
              ctx.font = font_size + "px arial";
              //looping over drops
              for(let i = 0; i < drops.length; i++)
              {
                  //a random chinese character to print
                  let text = this.matrix[Math.floor(Math.random()*this.matrix.length)];
                  // console.log('this.matrix B', this.matrix);
                  //x = i*font_size, y = value of drops[i]*font_size
                  ctx.fillText(text, i*font_size, drops[i]*font_size);
      
                  //sending the drop back to the top randomly after it has crossed the screen
                  //adding a randomness to the reset to make the drops scattered on the Y axis
                  if(drops[i]*font_size > c.nativeElement.height && Math.random() > 0.975)
                      drops[i] = 0;
      
                  //incrementing Y coordinate
                  drops[i]++;
              }
          }
      
          setInterval(draw, 35);
    
  }



}



// WEBPACK FOOTER //
// ./src/app/components/pricing/pricing.component.ts